import React from "react";
import { phoneCallLink } from "../utils/phone";

const linkStyle = { color: "#2977ed", textDecoration: "none" };
const stop = (e) => e.stopPropagation();

export const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || "").trim());

/** mailto link for an email; non-email text is shown as-is; empty -> "—". */
export function EmailLink({ email }) {
  const value = String(email || "").trim();
  if (!value || value === "—") return "—";
  if (!isEmail(value)) return value;
  return (
    <a href={`mailto:${value}`} style={linkStyle} onClick={stop}>
      {value}
    </a>
  );
}

/** "+91 987 654 3210" call link; a number without a dial code uses the default; empty -> "—". */
export function PhoneLink({ countryCode, number }) {
  const link = phoneCallLink(countryCode, number);
  if (!link) return "—";
  return (
    <a href={link.href} style={{ ...linkStyle, whiteSpace: "nowrap" }} onClick={stop}>
      {link.display}
    </a>
  );
}

/** Call link that keeps the number exactly as stored (toll-free / short codes have no dial code). */
export function RawPhoneLink({ number }) {
  const value = String(number || "").trim();
  const digits = value.replace(/[^\d+]/g, "");
  if (!digits || value === "—") return "—";
  return (
    <a href={`tel:${digits}`} style={{ ...linkStyle, whiteSpace: "nowrap" }} onClick={stop}>
      {value}
    </a>
  );
}
